export enum KeyboardEventKey {
  Enter = 'Enter',
  Space = ' ',
}
